import { Injectable } from '@angular/core';
import { RegelmotorService } from '../routes/regelmotor.service';
import { ListItem } from '../../berakningshjalpen/shared/classes/list-item.class';
import { Land } from '../../berakningshjalpen/shared/models/land.model';
import { DinaUppgifter } from '../../berakningshjalpen/shared/models/dina-uppgifter.model';
import { ValutakursService } from '../routes/valutakurs.service';
import { ValutakursParam } from '../../berakningshjalpen/shared/classes/form-underlag.class';
import { RegelmotorInput } from '../../berakningshjalpen/shared/models/regelmotorInput.model';
import { Valutakurs } from '../../berakningshjalpen/shared/models/valutakurs.model';
import { Inkomsttyp } from '../../berakningshjalpen/shared/enums/inkomsttyp.enum';
import { InfotexterInput } from '../../berakningshjalpen/shared/models/infotexterInput.model';

@Injectable({
  providedIn: 'root'
})
export class DinaUppgifterBFFService {
  constructor(
    private readonly regelmotorService: RegelmotorService,
    private readonly valutakursService: ValutakursService) {
  }

  getDittUnderlagViewModel(): any {
    const promises: PromiseLike<any>[] = [];
    promises.push(this.regelmotorService.getValutor());
    promises.push(this.regelmotorService.getLander(Inkomsttyp.UTDELNING));
    promises.push(this.regelmotorService.getLander(Inkomsttyp.RANTA));

    return Promise.all(promises).then((response: any) => {

      const valutor = response[0];
      const landerUtdelning = response[1];
      const landerRanta = response[2];

      const vListItems = valutor.map((valuta: string) => ({value: valuta, text: valuta} as ListItem));
      vListItems.unshift({value: '-1', text: 'Annan valuta'});

      const lListItemsUtdelning = landerUtdelning.map((land: Land) => ({value: land.kod, text: land.namn} as ListItem));
      lListItemsUtdelning.unshift({value: '-1', text: 'Annat land'});

      const lListItemsRanta = landerRanta.map((land: Land) => ({value: land.kod, text: land.namn} as ListItem));
      lListItemsRanta.unshift({value: '-1', text: 'Annat land'});

      return {
        valutaListItems: vListItems,
        landerUtdelning: lListItemsUtdelning,
        landerRanta: lListItemsRanta,
      } as DinaUppgifter;
    });
  }

  getInfotexter(infotexterInput: InfotexterInput): PromiseLike<any> {
    return this.regelmotorService.getInfotexter(infotexterInput)
      .then(response => response);
  }


  getResultat(regelmotorInput: RegelmotorInput): PromiseLike<any> {
    return this.regelmotorService.getResultat(regelmotorInput);
  }

  getValutaKurser(valutakursParam: ValutakursParam): PromiseLike<any> {
    const promises = this.valutakursPromises(valutakursParam);
    return Promise.all(promises)
      .then((responses: Valutakurs[]) => ({
          valutakurs: responses[0]?.kurs,
          valutakursSkatt: responses[1]?.kurs,
          bankdag: responses[0]?.bankdag,
          valutadag: responses[0]?.valutadag
        }));
  }

  private valutakursPromises(valutakursParam: ValutakursParam) {
    const promises: PromiseLike<any>[] = [];
    promises.push(this.valutakursService.getValutaKurser(valutakursParam.getValuta(), valutakursParam.getDatum()));
    if (valutakursParam.isValutaSkattValid()) {
      promises.push(this.valutakursService.getValutaKurser(valutakursParam.getValutaSkatt(), valutakursParam.getDatum()));
    }
    return promises;
  }

}
